import React from 'react';
import {Link} from 'react-router-dom';

import '../../styles/deskNav.scss'; 
import NameImage from '../../images/AlejandroAlfaro-negro.svg';

export default () => {

	return (
		<nav className='desk-nav'>
			
			<NameImage className='image-black' />

			<Link to='/' > Home</Link>
			<Link to='/projects'> Projects</Link>
			<Link to='/skills'> Skills</Link>
			<Link to='/employment'> Employment</Link>
			<Link to='/contact'>Contact </Link>
		</nav>

	)
}